import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { onHandlerHideView } from '../handler/ViewHandler';
import Utils from "@/common/utils/utils";
import { I18n } from 'aws-amplify';

export const DialogConfirmHideView = (props) => {
    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setIsConfirmHideView(false);
    };

    const showMsgConfirmHideView = () => {
        if (Utils.isEmptyArray(props?.chatbotCategories)) return I18n.get('COMMSG032');

        const viewIdsOfChatbotCategories = props?.chatbotCategories?.map(
            i => i?.chatBotCategorySetting?.viewId
        );
        
        if (viewIdsOfChatbotCategories?.includes(props?.view?.id))
            return I18n.get('MSG-KNOW-HIDE-VIEW-SETTING-CATEGORY');

        return I18n.get('COMMSG032');
    };

    return (
        <Dialog
            open={props.isConfirmHideView}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                   {showMsgConfirmHideView()}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={() => onHandlerHideView(props.view, props)}
                    className="btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                >
                    はい
                </Button>
                <Button
                    className="btn-light btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    いいえ
                </Button>
            </DialogActions>
        </Dialog>
    );
};
